import { createSlice } from "@reduxjs/toolkit";

// export const initialBasicInformation = {
//   aadhar_number: "",
//   first_name: "",
//   phoneNum: "",
//   emergency_contact_number: "",
//   email: "",
//   gender: "",
//   dateOfBirth: "",
//   age: "",
//   placeOfBirth: "",
//   bloodGroup: "",
//   religion: "",
//   personalIdentificationMark: "",
//   employmentType: "",
//   employeeCategory: "",
//   referralNumber: "",
// };

export const initialBasicInformation = {
  first_name: "",
  email_id: "",
  phoneNum: "",
  placeofBirth: "",
  DateofBirth: "",
  gender: "",
  age: "",
  aadhar_number: "",
  personal_identification_mark: "",
  religion: "",
  emergency_contact_number: "",
  blood_group: "",
  referral_number: "",
  city: "",
  state: "",
  employee_type: "",
  employee_category: "",
};

// export const initialAddressDetails = {
//   permanentStreet: "",
//   permanentTown: "",
//   permanentCity: "",
//   permanentState: "Select",
//   permanentPincode: "",
//   presentStreet: "",
//   presentTown: "",
//   presentCity: "",
//   presentState: "Select",
//   presentPincode: "",
// };

export const initialAddressDetails = {
  // permanent_street: "",
  // permanent_town: "",
  // permanent_city: "",
  // permanent_state: "Select",
  // permanent_pincode: "",

  // present_street: "",
  // present_town: "",
  // present_city: "",
  // present_state: "Select",
  // present_pincode: "",

  // present address
  street_name: "",
  town_name: "",
  city_name: "",
  state_name: "",
  pin_code: "",
  state_id: "",

  // permanent address
  street_name1: "",
  town_name1: "",
  city_name1: "",
  state_name1: "",
  pin_code1: "",
  state_id1: "",
};

// export const initialJobInformation = {
//   site: "",
//   client: "",
//   designation: "",
//   indicativeSalary: "",
//   rm: "",
//   pm: "",
//   vh: "",
//   projectCode: "",
//   programCode: "",
//   clientCode: "",
//   divisionCode: "",
//   divisionName: "",
//   medicalInsurance: "",
//   accidentInsurance: "",
//   premiumInsurance: "",
//   variableSalary: "",
//   statutoryBonus: "",
//   professionalTax: "",
//   bonus: "",
//   mobileExpenses: "",
//   conveyanceReimbursement: "",
//   retentionBonus: "",
//   gratuity: "",
//   daSalary: "",
//   caSalary: "",
//   swaSalary: "",
//   projectNature: "Select",
//   billingAbility: "Select",
//   billingType: "Select",
//   basicSalary: "",
//   hra: "",
//   addBasicSalary: true,
//   otherAllowances: "",
//   employeeESI: "",
//   employeePF: "",
//   airtimeAllowance: "",
//   netSalary: "",
// };

export const initialJobInformation = {
  job_title: "",
  department: "",
  designation: "",
  designation_id: "",
  gross_salary: "",
  timeline_id: "",
  client_id: "",

  other_allowances_salary: "",
  net_salary: "",
  hra_salary: "",
  employee_PF: "",
  employee_ESI: "",
  airtime_allowance: "",
  basic_salary: "",

  project_code: "",
  program_code: "",
  client_code: "",
  division_code: "",
  division_name: "",

  medical_insurance: "",
  accident_insurance: "",
  premium_insurance: "",

  variable_salary: "",
  da_salary: "",
  ca_salary: "",
  swa_salary: "",
  stationary_bonus: "",
  professional_tax: "",
  bonus: "",
  mobile_expenses: "",
  retention_bonus: "",
  conveyance: "",

  is_gratuity: false,
  addBasicSalary: false,

  rm_id: "",
  pm_id: "",
  vh_id: "",

  project_nature: "",
  billabilty: "",
  billing_type: "",

  job_status: "0",
  end_date: "",
};

// export const initialIdVerification = {
//   aadhaarNumber: "",
//   panNumber: "",
// };

export const initialIdVerification = {
  aadhar_number: "",
  pan_number: "",
};

// export const initialBankDetails = {
//   accountHolderName: "",
//   bankName: "",
//   bankBranch: "",
//   ifscCode: "",
//   accountNumber: "",
//   phoneNumber: "",
//   remark: "",
//   documentType: "passbook", // "cheque" | "passbook"
// };

export const initialBankDetails = {
  account_holder_name: "",
  bank_name: "",
  bank_branch: "",
  ifsc_code: "",
  account_number: "",
  phone_number: "",
  remarks: "",
  documentType: "passbook",
};

export const initialEducationDetails = {
  entries: [],
  educationSkipped: false, //added for the storing the skipped status
};

export const initialPreviousEmploymentDetails = {
  isFresher: false,
  entries: [],
};

// export const initialDeclarationDetails = {
//   familyMember: "",
//   personName: "",
//   dateOfBirth: "",
//   gender: "",
//   maritalStatus: "",
//   email: "",
//   mobileNo: "",
//   uan: "",
//   previousPf: "",
//   exitDate: "",
//   schemeCert: "",
//   ppo: "",
//   earlierPf: "No",
//   earlierPension: "No",
//   internationalWorker: "No",
//   bankAccount: "",
//   ifscCode: "",
//   aadhaarNumber: "",
//   panNumber: "",
//   countryOfOrigin: "",
//   passportNumber: "",
//   passportFrom: "",
//   passportTo: "",
// };

export const initialDeclarationDetails = {
  family_member: "",
  person_name: "",
  date_of_birth: "",
  gender: "",
  marital_status: "",
  email_id: "",
  mobile_no: "",
  uan: "",
  previous_pf: "",
  exit_date: "",
  scheme_certificate: "",
  ppo_number: "",
  earlier_pf: "No",
  earlier_pension: "No",
  international_worker: "No",
  bank_account: "",
  ifsc_code: "",
  aadhar_number: "",
  pan_number: "",
  country_of_origin: "",
  passport_number: "",
  passport_validity_from: "",
  passport_validity_to: "",

  // timeline_id:"",
  // passport:"",
};

// export const initialEsiDetails = {
//   relationType: "father", // father | husband
//   esiNumber: "",
//   esiDispensary: "",
//   epf: "",
//   eps: "",
//   attendanceCycle: "",
//   contractDuration: "",
//   contractEndDate: "",
//   noticeBefore: "",
//   noticeAfter: "",
//   nominees: [
//     {
//       id: 1,
//       name: "",
//       address: "",
//       relationship: "",
//       share: "",
//       dob: "",
//       guardian: "",
//       image: null,
//     },
//   ],
// };

// export const initialEsiDetails={
//   NameofFamily:
// }

export const initialEsiDetails = {
  // Relation section
  NameOfFamliy: "father", // father | husband
  FatherORHUSBANDNAME: "",

  // ESI fields
  previous_ESI_number: "",
  esi_dispensary: "",

  e_p_f: "",
  e_p_s: "",

  attendance_cycle: "",
  contract_duration: "",
  contract_end_date: "",
  notice_period_before: "",
  notice_period: "",

  nominees: [
    {
      id: 1,
      name: "",
      address: "",
      relationship: "",
      share: "",
      dob: "",
      guardian: "",
      image: null,
    },
  ],

  timeline_id: "",
};
const initialState = {
  basicInformation: initialBasicInformation,
  basicImages: {
    aadhaarFront: null,
    profile: null,
  },
  addressDetails: initialAddressDetails,
  addressImages: {
    aadhaarBack: null,
  },
  sameAsPermanent: false,
  jobInformation: initialJobInformation,
  idVerification: initialIdVerification,
  idVerificationImages: {
    pan: null,
  },

  bankDetails: initialBankDetails,
  bankImages: {
    document: null,
  },

  educationDetails: initialEducationDetails,
  educationImages: {}, // key: id → file
  previousEmploymentDetails: initialPreviousEmploymentDetails,
  previousEmploymentImages: {},

  declarationDetails: initialDeclarationDetails,
  declarationImages: {
    passport: null,
  },

  // esiDetails: {
  //   relationType: "Father",
  //   relationName: "",
  //   joiningDate: "",
  //   epf: "",
  //   eps: "",
  //   maritalStatus: "",
  //   esiNumber: "",
  //   esiDispensary: "",
  //   attendanceCycle: "",
  //   contractDuration: "",
  //   contractEndDate: "",
  //   noticeBefore: "",
  //   noticeAfter: "",
  //   gender: "",
  //   nominees: [
  //     {
  //       id: 1,
  //       name: "",
  //       address: "",
  //       relationship: "",
  //       share: "",
  //       dob: "",
  //       guardian: "",
  //       image: null,
  //     },
  //   ],
  // },
  esiDetails: initialEsiDetails,
};

const employeeInformationSlice = createSlice({
  name: "employeeInformation",
  initialState,
  reducers: {
    updateBasicField: (state, action) => {
      const { name, value } = action.payload;
      state.basicInformation[name] = value;
    },

    setBasicImage: (state, action) => {
      const { name, image } = action.payload;
      state.basicImages[name] = image;
    },

    removeBasicImage: (state, action) => {
      state.basicImages[action.payload] = null;
    },

    updateAddressField: (state, action) => {
      const { name, value } = action.payload;
      state.addressDetails[name] = value;

      if (state.sameAsPermanent && name.startsWith("permanent")) {
        state.addressDetails[name.replace("permanent", "present")] = value;
      }
    },

    // setSameAsPermanent: (state, action) => {
    //   state.sameAsPermanent = action.payload;

    //   if (action.payload) {
    //     state.addressDetails.presentStreet =
    //       state.addressDetails.permanentStreet;
    //     state.addressDetails.presentTown = state.addressDetails.permanentTown;
    //     state.addressDetails.presentCity = state.addressDetails.permanentCity;
    //     state.addressDetails.presentState = state.addressDetails.permanentState;
    //     state.addressDetails.presentPincode =
    //       state.addressDetails.permanentPincode;
    //   }
    // },

    setSameAsPermanent: (state, action) => {
      state.sameAsPermanent = action.payload;

      if (action.payload) {
        state.addressDetails.street_name = state.addressDetails.street_name1;
        state.addressDetails.town_name = state.addressDetails.town_name1;
        state.addressDetails.city_name = state.addressDetails.city_name1;
        state.addressDetails.state_name = state.addressDetails.state_name1;
        state.addressDetails.pin_code = state.addressDetails.pin_code1;
      }
    },

    setAddressImage: (state, action) => {
      const { name, image } = action.payload;
      state.addressImages[name] = image;
    },

    removeAddressImage: (state, action) => {
      state.addressImages[action.payload] = null;
    },

    updateJobField: (state, action) => {
      const { name, value } = action.payload;
      state.jobInformation[name] = value;
    },
    updateIdField: (state, action) => {
      const { name, value } = action.payload;
      state.idVerification[name] = value;
    },

    setIdImage: (state, action) => {
      const { name, image } = action.payload;
      state.idVerificationImages[name] = image;
    },

    removeIdImage: (state, action) => {
      state.idVerificationImages[action.payload] = null;
    },

    updateBankField: (state, action) => {
      const { name, value } = action.payload;
      state.bankDetails[name] = value;
    },

    setBankImage: (state, action) => {
      const { name, image } = action.payload;
      state.bankImages[name] = image;
    },

    removeBankImage: (state, action) => {
      state.bankImages[action.payload] = null;
    },

    addEducation: (state, action) => {
      state.educationDetails.entries.push(action.payload);
    },

    removeEducation: (state, action) => {
      const id = action.payload;
      state.educationDetails.entries = state.educationDetails.entries.filter(
        (e) => e.id !== id,
      );

      delete state.educationImages[id];
    },

    updateEducationField: (state, action) => {
      const { id, name, value } = action.payload;
      const entry = state.educationDetails.entries.find((e) => e.id === id);
      if (entry) entry[name] = value;
    },

    setEducationImage: (state, action) => {
      const { id, image } = action.payload;
      state.educationImages[id] = image;
    },

    removeEducationImage: (state, action) => {
      delete state.educationImages[action.payload];
    },

    setEducationSkipped: (state, action) => {
      state.educationSkipped = action.payload;
    },

    setPreviousEmploymentFresher: (state, action) => {
      state.previousEmploymentDetails.isFresher = action.payload;

      if (action.payload) {
        state.previousEmploymentDetails.entries = [];
        state.previousEmploymentImages = {};
      }
    },

    addPreviousEmployment: (state, action) => {
      state.previousEmploymentDetails.isFresher = false;
      state.previousEmploymentDetails.entries.push(action.payload);
    },

    removePreviousEmployment: (state, action) => {
      const id = action.payload;
      state.previousEmploymentDetails.entries =
        state.previousEmploymentDetails.entries.filter(
          (entry) => entry.id !== id,
        );
      delete state.previousEmploymentImages[id];
    },

    updatePreviousEmploymentField: (state, action) => {
      const { id, name, value } = action.payload;
      const entry = state.previousEmploymentDetails.entries.find(
        (item) => item.id === id,
      );

      if (entry) {
        entry[name] = value;
      }
    },

    setPreviousEmploymentImage: (state, action) => {
      const { id, image } = action.payload;
      state.previousEmploymentImages[id] = image;
    },

    removePreviousEmploymentImage: (state, action) => {
      delete state.previousEmploymentImages[action.payload];
    },

    updateDeclarationField: (state, action) => {
      const { name, value } = action.payload;
      state.declarationDetails[name] = value;
    },

    setDeclarationImage: (state, action) => {
      const { name, image } = action.payload;
      state.declarationImages[name] = image;
    },

    removeDeclarationImage: (state, action) => {
      state.declarationImages[action.payload] = null;
    },

    // Update main ESI fields
    updateEsiField: (state, action) => {
      const { name, value } = action.payload;
      state.esiDetails[name] = value;
    },

    addNominee: (state) => {
      if (state.esiDetails.nominees.length >= 4) return;

      state.esiDetails.nominees.push({
        id: Date.now(),
        name: "",
        address: "",
        relationship: "",
        share: "",
        dob: "",
        guardian: "",
        image: null,
      });
    },

    updateNomineeField: (state, action) => {
      const { id, name, value } = action.payload;

      const nominee = state.esiDetails.nominees.find((n) => n.id === id);

      if (nominee) {
        nominee[name] = value;
      }
    },

    setNomineeImage: (state, action) => {
      const { id, image } = action.payload;

      const nominee = state.esiDetails.nominees.find((n) => n.id === id);

      if (nominee) {
        nominee.image = image;
      }
    },

    removeNominee: (state, action) => {
      if (state.esiDetails.nominees.length <= 1) return;

      state.esiDetails.nominees = state.esiDetails.nominees.filter(
        (n) => n.id !== action.payload,
      );
    },

    removeNomineeImage: (state, action) => {
      const { id } = action.payload;

      const nominee = state.esiDetails.nominees.find((n) => n.id === id);

      if (nominee) {
        nominee.image = null;
      }
    },
  },
});

export const {
  updateBasicField,
  setBasicImage,
  removeBasicImage,
  updateAddressField,
  setSameAsPermanent,
  setAddressImage,
  removeAddressImage,
  updateJobField,
  updateIdField,
  setIdImage,
  removeIdImage,
  removeBankImage,
  setBankImage,
  updateBankField,
  addEducation,
  removeEducation,
  updateEducationField,
  setEducationImage,
  removeEducationImage,
  setPreviousEmploymentFresher,
  addPreviousEmployment,
  removePreviousEmployment,
  updatePreviousEmploymentField,
  setPreviousEmploymentImage,
  removePreviousEmploymentImage,
  updateDeclarationField,
  setDeclarationImage,
  removeDeclarationImage,
  updateEsiField,
  addNominee,
  updateNomineeField,
  setNomineeImage,
  removeNominee,
  removeNomineeImage,
  setEducationSkipped,
} = employeeInformationSlice.actions;

export const selectEmployeeInformation = (state) => state.employeeInformation;

export default { employeeInformation: employeeInformationSlice.reducer };
